import React from 'react';

import Spinner from '../../common/genericComponents/spinner';
import Caret from '../../../assets/svgComponents/Caret';

import userService from '../../../services/restServices/userService';

import './datePickerComponent.css';

const DatePickerComponentRender = (props) => {
  const {
    isBoundedMonths,
    subMonth,
    selectedMonthYear,
    selectedMonth,
    addMonth,
    dayNames,
    daysArray,
    isLoading,
    selectedDayInMonth,
    checkIfDayIsValid,
    setDate,
    isCurrentDay,
  } = props;

  return (
    <div className="et-n-date-picker-wrap">
      <div className="et-n-dp-month-line">
        <div className="et-n-dp-prev-month" onClick={subMonth}>
          <Caret fillColor="var(--et-mentor-primary-text-color)" />
        </div>
        {isBoundedMonths
          ? selectedMonthYear
          : userService.capitalizeFirstLetter(selectedMonth)}
        <div className="et-n-dp-next-month" onClick={addMonth}>
          <Caret fillColor="var(--et-mentor-primary-text-color)" />
        </div>
      </div>

      <div className="et-n-dp-week-days">
        {dayNames.map((weekDay) => (
          <div className="et-n-dp-weekday" key={weekDay}>
            {weekDay.substr(0, 1)}
          </div>
        ))}
      </div>

      {isLoading ? (
        <div className="et-n-dp-spinner-wrap">
          <Spinner />
        </div>
      ) : (
        <div className="et-n-dp-month-days">
          {daysArray.map((day, index) => (
            <div
              className={
                'et-n-dp-month-day ' +
                (selectedDayInMonth &&
                day === selectedDayInMonth &&
                checkIfDayIsValid(day)
                  ? ' et-n-dp-month-day-selected'
                  : checkIfDayIsValid(day)
                    ? ''
                    : ' et-n-dp-month-day-invalid ')
              }
              onClick={() => setDate(day)}
              key={index}>
              {day}

              <span
                className={isCurrentDay(day) ? 'et-current-day' : ''}></span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DatePickerComponentRender;
